import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { getC3TimeSeriesColumns, type C3TimeSerie } from "./columns";
import { type FilterC3TimeSeriesSchema, FilterC3TimeSeries } from "./filter";

export const C3TimeSeriesTable = () => {
  const { t } = useTranslation();
  const columns = getC3TimeSeriesColumns(t);

  return (
    <Table<C3TimeSerie, FilterC3TimeSeriesSchema>
      label={t(`${Tables.C3_TIME_SERIES}.title`, {
        ns: "tables",
        defaultValue: "Valorisations",
      })}
      client={Clients.C3}
      table_name={Tables.C3_TIME_SERIES}
      columns={columns}
      filter={<FilterC3TimeSeries />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C3}/${Tables.C3_TIME_SERIES}/new`,
        },
      ]}
    />
  );
};
